import { useState } from "react";
import { toast } from 'react-toastify';
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Skeleton from "@mui/material/Skeleton";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";
import CloseIcon from "@mui/icons-material/Close";
import { noop } from "@client/shared/constants";
import style from '../style';
import UplaodFile from "./upload-file";
import AudioRecorder from "./audio-recorder";
import CallToRecord from "./call-to-record";
import Service from '../service';

const RECORDING_TYPES = [
  { label: 'Upload an audio file from your computer.', value: 1 },
  { label: 'Record a audio from your computer.', value: 2 },
  { label: 'Have RingCentral call me to record.', value: 3 },
];

const defaultState = {
  recordingType: RECORDING_TYPES[0].value,
  audioFile: null,
  isUploading: false,
  fileUploadingFromSystem: false,
	onFileUplaod: noop
};

const Recorder = ({
  open = false,
  extensionId = null,
  countryList = [],
  handleClose = noop,
}) => {
  const [state, setState] = useState(defaultState);

  const handleUpload = async () => {
    setState(prevState => ({
      ...prevState,
      isUploading: true,
    }));

    const formData = new FormData();
    formData.append("file", state.audioFile);
    const { error } = await Service.uploadGreeting(extensionId, formData);
    setState(prevState => ({
      ...prevState,
      isUploading: false,
    }));
    if (error) {
      toast.error(Array.isArray(error) ? error[0]?.message : error);
    } else {
      toast.success("Greeting Media Applied Successfully.");
      handleClose(true);
    }
  };
  
  const getAudio = (audioFile) => {
		return audioFile ? (window.URL || window.webkitURL).createObjectURL(audioFile) : "";
	};

  return (
    <Dialog
      open={open}
      onClose={() => handleClose()}
    >
      <DialogTitle hasClose>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h6" sx={{ mt: 2 }}>
            Change Greeting Media
          </Typography>
          <IconButton>
            <CloseIcon
              sx={{ color: "grey.600" }}
              fontSize="small"
              onClick={() => handleClose()}
            />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ ...style.recorderContent }}>
        <FormControl sx={{ mb: 8 }}>
          <RadioGroup
            name="recordingType"
            value={state.recordingType}
            onChange={evt => {
            const value = evt.target.value;
              setState(prevState => ({
                ...prevState,
                recordingType: +value,
                audioFile: null
              }))
            }}
          >
            {RECORDING_TYPES.map((radio, index) => (
              <FormControlLabel
                key={index}
                value={radio.value}
                label={<Typography variant="body1">{radio.label}</Typography>}
                control={<Radio size="small" />}
              />
            ))}
          </RadioGroup>
        </FormControl>
        {state.recordingType === 1 && (
          <UplaodFile
            audioFile={state.audioFile}
            onAudioChange={audioFile => {
              setState(prevState => ({
                ...prevState,
                audioFile,
                fileUploadingFromSystem: false,
              }));
            }}
            showFileUploadLoader={(show = false) => {
              setState(prevState => ({
                ...prevState,
                fileUploadingFromSystem: show,
              }));
            }}
          />
        )}
        {state.recordingType === 2 && (
          <AudioRecorder
            audioFile={state.audioFile}
            onAudioChange={audioFile => {
              setState(prevState => ({
                ...prevState,
                audioFile
              }));
            }}
          />
        )}
        {state.recordingType === 3 && (
          <CallToRecord
            extensionId={extensionId}
            countryList={countryList}
            handleClose={handleClose}
          />
        )}
        {state.fileUploadingFromSystem && (
          <Skeleton width="100%" height={56} sx={{ borderRadius: 5, mt: 6 }} />
        )}
        {!!(!state.fileUploadingFromSystem && state.audioFile) && (
          <Box sx={{ mt: 8 }}>
            <audio style={{ width: "100%", height: "36px"}} controls src={getAudio(state.audioFile)}></audio>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          sx={{ mb: 4, mr: state.recordingType === 3 ? 8 : 2 }}
          variant="outlined"
          onClick={() => handleClose(state.recordingType === 3)}
        >
          {state.recordingType === 3 ? "Close" : "Cancel"}
        </Button>
        {state.recordingType !== 3 && (
          <Button
            sx={{ mb: 4, mr: 8 }}
            variant="contained"
            disabled={!state.audioFile || state.isUploading}
            onClick={handleUpload}
          >
            {state.isUploading && <CircularProgress sx={{ position: "absolute" }} size={18} />}
            Apply
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default Recorder;